import { shouldWarnLowQualityDefault } from 'components/PhotoBank/photoUtils'
import { isPhotoCover } from 'components/PhotoBook/PhotoBookProvider/PhotoBook.utils'
import { MIN_PHOTO_BOOK_PAGES } from '@mixtiles/web-backend-shared'
import { photosInPages } from 'services/PhotoBook/photoBookUtils'
import type { StoredPhotoBook } from 'services/PhotoBook/photoBookSaver.types'
import type { PhotoBankStore } from 'stores/photoBankStore/PhotoBankStore'
import type { PhotoBookCartItemWarning } from '../../CartItem'

export function computePhotoBookWarnings(
  bookData: StoredPhotoBook,
  photosCount: number,
  photoBankStore: PhotoBankStore
): PhotoBookCartItemWarning[] {
  const warnings: PhotoBookCartItemWarning[] = []

  if (photosCount < MIN_PHOTO_BOOK_PAGES) {
    warnings.push({
      type: 'not-enough-photos',
      missingPhotos: MIN_PHOTO_BOOK_PAGES - photosCount,
    })
  }

  const allStoredPhotos = [
    ...(isPhotoCover(bookData.cover) ? [bookData.cover.photo] : []),
    ...photosInPages(bookData.pages),
  ]

  const hasLowResPhoto = allStoredPhotos.some((storedPhoto) => {
    if (storedPhoto.lowQualityApproved) return false
    const photo = photoBankStore.getPhoto(storedPhoto.uid)
    if (!photo) return false
    return shouldWarnLowQualityDefault({
      width: photo.width,
      height: photo.height,
    })
  })

  if (hasLowResPhoto) {
    warnings.push({ type: 'lowres' })
  }

  return warnings
}
